import type { WarmTransfer, WarmTransferHandled } from './types';

export const ACTIVE_TRANSFERS: WarmTransfer[] = [
  {
    id: 't1',
    priority: 'priority',
    patient: { name: 'John Doe' },
    reason: 'Billing Dispute',
    ago: '1 min ago',
    status: 'frustrated',
    duration: 252,
    info: {
      dob: '04/12/1985',
      phone: '(415) 555-0192',
      zip: '90210',
      insurance: 'Delta Dental',
    },
    aiSummary: [
      'Patient is calling about a $50 balance they believe was already paid last month.',
      'Elva verified their Delta Dental policy is active and confirmed zero remaining deductible.',
      'Patient became agitated regarding the billing error and requested to speak with a human manager immediately.',
    ],
  },
  {
    id: 't2',
    priority: 'active',
    patient: { name: 'Maria Garcia' },
    reason: 'Scheduling — new patient',
    ago: 'Just now',
    status: 'neutral',
    duration: 142,
    info: {
      dob: '09/22/1979',
      phone: '(415) 555-3392',
      zip: '94110',
      insurance: 'MetLife PPO',
    },
    aiSummary: [
      'Patient wants to reschedule her cleaning from next Tuesday afternoon.',
      'Confirmed she prefers Thursday or Friday afternoons with Dr. Lin.',
      'Requested to speak with front desk to confirm a 30-minute slot.',
    ],
  },
  {
    id: 't3',
    priority: 'active',
    patient: { name: 'Theo Park' },
    reason: 'Post-op concern — implant site',
    ago: 'Just now',
    status: 'anxious',
    duration: 38,
    info: {
      dob: '11/04/1968',
      phone: '(415) 555-2218',
      zip: '94114',
      insurance: 'Cigna Dental',
    },
    aiSummary: [
      'Patient reports tenderness at implant site, day 5 post-op.',
      'Described mild swelling, no fever. Above the threshold for self-care guidance.',
      'Escalating to Dr. Lin for a 30-second voice consult per post-op protocol.',
    ],
  },
];

export const HANDLED_TRANSFERS: WarmTransferHandled[] = [
  { id: 'h1', patient: 'Aaron Klein', ago: 'Handled 15m ago' },
  { id: 'h2', patient: 'Sandra Williams', ago: 'Handled 22m ago' },
  { id: 'h3', patient: 'James Martinez', ago: 'Handled 34m ago' },
  { id: 'h4', patient: 'Patricia Lee', ago: 'Handled 47m ago' },
  { id: 'h5', patient: 'Lisa Park', ago: 'Handled 1 hr ago' },
];

export function synthHandledTransfer(item: WarmTransferHandled): WarmTransfer {
  return {
    id: item.id,
    priority: 'handled',
    patient: { name: item.patient },
    reason: 'Handled earlier today',
    ago: item.ago,
    status: 'neutral',
    duration: 0,
    info: { dob: '—', phone: '—', zip: '—', insurance: '—' },
    aiSummary: [
      'This transfer has already been picked up and resolved.',
      'Full conversation context and outcome are available in the transcript.',
      'No action is required — archived for reference.',
    ],
  };
}
